import React from "react";
import { Link } from "react-router-dom";
import { ModelManager } from "../../lib/model-manager";
import { ProjectForm } from "./ProjectForm";

export default class UpdateProject extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      element: null,
      isLoading: false,
      error: false,
    };

    this.getElement = this.getElement.bind(this);
  }

  componentDidMount() {
    this.getElement();
  }

  getElement() {
    this.setState({ isLoading: true });
    ModelManager.fetch("/api/projects", this.props.match.params.projectId)
      .finally(() => {
        this.setState({ isLoading: false });
      })
      .then((element) => {
        this.setState({ element });
      })
      .catch(() => {
        this.setState({ error: true });
      });
  }

  render() {
    return (
      <>
        <ul className="breadcrumb">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/projects">Projets</Link>
          </li>
          <li className="active">Créer un projet</li>
        </ul>

        <div className="page-title">
          <h2>
            <span className="fa fa-arrow-circle-o-left" />
            &nbsp;Modifier un projet
          </h2>
        </div>

        <div className="page-content-wrap">
          <div className="panel panel-default">
            <div className="panel-body">
              <p>Indiquer les informations suivantes pour créer votre projet</p>
            </div>
            <div className="panel-body form-group-separated">
              {this.state.isLoading && (
                <div className="loading">
                  <img src="/loading.gif" alt="loading" />
                </div>
              )}
              {this.state.isLoading === false && this.state.element && (
                <ProjectForm project={this.state.element} />
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}
